import { render, staticRenderFns } from "./InstallationIcon.vue?vue&type=template&id=61d47141&scoped=true&"
import script from "./InstallationIcon.vue?vue&type=script&lang=js&"
export * from "./InstallationIcon.vue?vue&type=script&lang=js&"
import style0 from "./InstallationIcon.vue?vue&type=style&index=0&id=61d47141&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d47141",
  null
  
)

export default component.exports